import { object, string } from 'yup';

export const ContactRequestSchema = object().shape({
  firstName: string().required(),
  lastName: string().required(),
  email: string().email().required(),
  phoneNumber: string(),
  message: string().required(),
});
